import { mountWikiSidebar } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/mount_sidebar.js?vue3';
import { mountWikiApp, mountSidebarResizer } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/mount_content.js?vue3';

export const mountApplications = () => {
  mountWikiApp();
  mountSidebarResizer();
  mountWikiSidebar();
};
